import { CoreIcon } from '../core-icon';
import invoiceSVG from '../../../src/images/icons/invoice.svg';

export const InvoiceIcon = props => {
  return <CoreIcon src={invoiceSVG} {...props} />;
};
